var map = {
	"./g001/Ikro.jpeg": "9720",
	"./g001/SaintsTombCover.jpg": "092b",
	"./g001/Valnok.jpeg": "c995",
	"./g001/bat.png": "f225",
	"./g001/beer.jpeg": "1cdb",
	"./g001/catacomb.jpeg": "a5d2",
	"./g001/chuck.jpeg": "9406",
	"./g001/door.jpeg": "12f8",
	"./g001/gates.jpeg": "620b",
	"./g001/graves.jpeg": "9ec9",
	"./g001/inside.jpeg": "c031",
	"./g001/jackal.png": "ed92",
	"./g001/oldman.jpeg": "092bf",
	"./g001/rat.jpeg": "2219",
	"./g001/room.jpeg": "07eb",
	"./g001/skeleton.jpeg": "4b61",
	"./g001/temple.jpeg": "9d02",
	"./g001/tomb.jpeg": "57c6",
	"./g002/TLOfields.jpg": "9182",
	"./g002/TLOmain.jpg": "2ef5",
	"./g002/TLOruins.jpg": "139b",
	"./g002/TLOstaircase.jpg": "7242",
	"./g002/TLOstreets.jpg": "5bcb",
	"./g002/magos_city.jpg": "8faa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f42";